import createStore from '~aliases/store/create-store'

const store = createStore()
export default store

if (DEBUG) {
  window.store = store
}
